
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 480 480"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M304 160H168.224c-6.464 0-12.288 3.904-14.784 9.888-2.464 5.952-1.088 12.864 3.488 17.44l33.952 33.952L21.184 391.008c-6.24 6.24-6.24 16.384 0 22.624l45.248 45.248c3.136 3.136 7.232 4.672 11.328 4.672s8.192-1.568 11.328-4.672l169.728-169.728 33.856 33.92a15.918 15.918 0 0 0 17.44 3.456c5.984-2.464 9.888-8.32 9.888-14.784V176c0-8.832-7.168-16-16-16zm-16 113.12l-17.952-17.92c-6.24-6.24-16.384-6.24-22.624 0L77.728 424.896l-22.624-22.624L224.8 232.544c6.24-6.24 6.24-16.384 0-22.624L206.848 192H288v81.12z"}}),_c('path',{attrs:{"d":"M464 0H16C7.168 0 0 7.168 0 16v320c0 8.832 7.168 16 16 16s16-7.168 16-16V32h416v416H144c-8.832 0-16 7.168-16 16s7.168 16 16 16h320c8.832 0 16-7.168 16-16V16c0-8.832-7.168-16-16-16z"}})])
          )
        }
      }
    